import BaseCrudService from './baseCrud.service'

class SaleService extends BaseCrudService {
  constructor () {
    super('sale', {
      id: false,
      client_id: 0,
      language: 'en',
      loan_based: 0,
      sign_location: 'cc',
      discount: 0,
      workflowStatus: '',
      apartments: [],
      bank_belgian: false,
      bank_german: false,
      bank_name_belgian: '',
      bank_name_german: '',
      bank_amount_belgian: 0,
      bank_amount_german: 0,
      created_by: 1
    })
  }

  addApartments (itemId, apartmentIds, ...callbacks) {
    return this.constructor.post(
      this.endpoints().addApartments.replace('{:id}', itemId),
      { 'apartmentIds': apartmentIds },
      ...callbacks
    )
  }

  removeApartments (itemId, apartmentIds, ...callbacks) {
    return this.constructor.post(
      this.endpoints().removeApartments.replace('{:id}', itemId),
      { 'apartmentIds': apartmentIds },
      ...callbacks
    )
  }

  detachFiles (itemId, filesIds, ...callbacks) {
    return this.constructor.post(
      this.endpoints().detachFiles.replace('{:id}', itemId),
      { 'filesIds': filesIds },
      ...callbacks
    )
  }

  workflowUpdate (itemId, statusData, ...callbacks) {
    statusData = (typeof statusData === 'object' ? statusData : { status: statusData })
    return this.constructor.put(
      this.endpoints().workflowUpdate.replace('{:id}', itemId),
      statusData,
      ...callbacks
    )
  }

  slotWorkflowUpdate (itemId, slotCode, statusData, ...callbacks) {
    statusData = (typeof statusData === 'object' ? statusData : { status: statusData })
    statusData.slotCode = slotCode
    return this.constructor.put(
      this.endpoints().slotWorkflowUpdate.replace('{:id}', itemId),
      statusData,
      ...callbacks
    )
  }

  makePreReservation (itemId, empty, ...callbacks) {
    return this.constructor.get(this.endpoints().preReservationDownload.replace('{:id}', itemId), { params: { empty: empty || 0 } }, ...callbacks)
  }
}

export default SaleService
